import { redirectDocument } from 'react-router-dom';

export const indexRedirect = (): Response => {
  const { pathname } = window.location;
  if (pathname === '/login') {
    return redirectDocument('/auth', { status: 301 });
  }
  if (pathname === '/checkAccount') {
    return redirectDocument('/auth', { status: 301 });
  }
  if (pathname === '/conditions') {
    return redirectDocument('/loan-conditions', { status: 301 });
  }
  if (pathname === '/PageRegistration') {
    return redirectDocument('/auth', { status: 301 });
  }
  if (pathname === '/moneystep') {
    return redirectDocument('/how-get-money', { status: 301 });
  }
  if (pathname === '/accounting') {
    return redirectDocument('/', { status: 301 });
  }
  if (pathname === '/PaymentPage') {
    return redirectDocument('/payment', { status: 301 });
  }
  if (pathname === '/guide') {
    return redirectDocument('/faq', { status: 301 });
  }
  if (pathname === '/difficulty_repayment') {
    return redirectDocument('/debt-disposal', { status: 301 });
  }
  if (pathname === '/restructuring') {
    return redirectDocument('/cabinet', { status: 301 });
  }
  if (pathname === '/payment_methods') {
    return redirectDocument('/payments-info', { status: 301 });
  }
  if (pathname === '/PersonalAreaPage') {
    return redirectDocument('/auth', { status: 301 });
  }
  return redirectDocument('/', { status: 301 });
};
